export default __webpack_public_path__ + "static/media/logo.d169d3af.svg";